import PAUSED_BLACK from '../../static/images/eq-black-paused.gif';
import PLAYING_BLACK from '../../static/images/eq-black-playing.gif';
import PAUSED_BLUE from '../../static/images/eq-blue-paused.gif';
import PLAYING_BLUE from '../../static/images/eq-blue-playing.gif';
import PAUSED_WHITE from '../../static/images/eq-white-paused.gif';
import PLAYING_WHITE from '../../static/images/eq-white-playing.gif';

export const EqTypes = Object.freeze({
  PLAYING_WHITE,
  PLAYING_BLACK,
  PLAYING_BLUE,
  PAUSED_WHITE,
  PAUSED_BLACK,
  PAUSED_BLUE,
});

export const EqColors = Object.freeze({
  WHITE: 'white',
  BLACK: 'black',
  BLUE: 'blue',
});

export const EqSizes = Object.freeze({
  XSMALL: 'xsmall',
  SMALL: 'small',
  // no MEDIUM since it's the default
  LARGE: 'large',
});
